export function determinarPerfilSujeto(rolSujeto, esBC, esInmobiliaria) {
  if (esBC && esInmobiliaria) return 'N/A';
  if (esBC && !esInmobiliaria) return 'CLIENTE_DIRECTO';
  const r = (rolSujeto || '').toLowerCase();
  if (esInmobiliaria) {
    if (r === 'solicitante / contacto') return 'SOLO_DATOS';
    if (r === 'solicitante y comprador') return 'CLIENTE_DIRECTO';
    if (r === 'solicitante y vendedor') return 'CLIENTE_DIRECTO';
    if (r === 'vendedor') return 'CLIENTE_DIRECTO';
  }
  if (
    r.includes('<25%') ||
    r.includes('diluido') ||
    r.includes('vigente') ||
    r.includes('restante') ||
    r.includes('solo datos')
  ) {
    return 'SOLO_DATOS';
  }
  if (
    r.includes('delegado') ||
    r.includes('solicitante') ||
    r.includes('apoderado') ||
    r.includes('representante legal')
  ) {
    return 'DELEGADO';
  }
  if (
    r.includes('sociedad') ||
    r.includes('emisora') ||
    r.includes('liquidación') ||
    r.includes('fusionad') ||
    r.includes('fusionant') ||
    r.includes('escindent') ||
    r.includes('escindida') ||
    r.includes('empresa')
  ) {
    return 'SOCIEDAD';
  }
  return 'GENERAL';
}